import { IRepurchase } from '../interface/IRepurchase.interface';

export class RepurchaseModel {
  uid: string | null;
  promotion_snapshot?: any; // Puede ser de tipo any o ajustarlo según tus necesidades.
  repurchase_amount?: number;
  waiverImageURL?: string;
  paymentImageURL?: string;
  created_at?: string;
  updated_at?: string;
  isLatest?: boolean;

  constructor(repurchase?: IRepurchase | null) {
    this.uid = repurchase?.uid ?? null;
    this.repurchase_amount = repurchase?.repurchase_amount ?? 0;
    this.waiverImageURL = repurchase?.waiverImageURL ?? null;
    this.paymentImageURL = repurchase?.paymentImageURL ?? null;

    // Validación para created_at:
    // Si existe, se convierte a Date y se valida; si es inválido se asigna la fecha actual.
    if (repurchase?.created_at != null) {
      const dateCreated = new Date(repurchase.created_at);
      this.created_at = isNaN(dateCreated.getTime()) ? new Date().toISOString() : dateCreated.toISOString();
    } else {
      this.created_at = new Date().toISOString();
    }

    // Validación para updated_at:
    // Si existe, se convierte a Date y se valida; si es inválido o es null, se asigna null.
    if (repurchase?.updated_at != null) {
      const dateUpdated = new Date(repurchase.updated_at);
      this.updated_at = isNaN(dateUpdated.getTime()) ? null : dateUpdated.toISOString();
    } else {
      this.updated_at = null;
    }

    this.isLatest = repurchase?.isLatest ?? false;

    if (repurchase?.promotion_snapshot) {
      try {
        this.promotion_snapshot = JSON.parse(repurchase.promotion_snapshot);
      } catch (error) {
        console.error('Error parsing promotion_snapshot:', error);
        this.promotion_snapshot = null;
      }
    } else {
      this.promotion_snapshot = null;
    }
  }
}
